import { useMutation } from '@tanstack/react-query';

import {
  StandingAccessReportCreateAppModel,
  StandingAccessReportsApiReassessStandingAccessReportRequest,
  StandingAccessService,
} from '@api';

export function useCreateStandingAccessReport() {
  const { mutate, ...rest } = useMutation((params: StandingAccessReportCreateAppModel) =>
    StandingAccessService.createStandingAccessReport({
      standingAccessReportCreateAppModel: params,
    }),
  );

  return {
    createStandingAccessReport: mutate,
    ...rest,
  };
}

export function useReassessStandingAccessReport() {
  const { mutate, ...rest } = useMutation((params: StandingAccessReportsApiReassessStandingAccessReportRequest) =>
    StandingAccessService.reassessStandingAccessReport(params),
  );

  return {
    reassessStandingAccessReport: mutate,
    ...rest,
  };
}
